// eslint-disable-next-line no-use-before-define
import React, { FC, useState } from 'react';

import './PageWithTabs.scss';
import PageWithTabsError from './components/PageWithTabsError';
import PageWithTabsLoading from './components/PageWithTabsLoading';

export type Tab = {
  key: string;
  icon?: string;
  title: string;
  content: React.ReactNode;
};

type PageWithTabsProps = {
  id?: string;
  tabs: Tab[];
  onChangeTab?: (index: number) => void; // eslint-disable-line
  asideContent?: React.ReactNode;
  isLoading?: boolean;
  isError?: boolean;
};

const PageWithTabs: FC<PageWithTabsProps> = ({
  id = '',
  tabs,
  onChangeTab,
  asideContent,
  isLoading,
  isError,
}) => {
  const [currentPage, setCurrentPage] = useState<number>(0);

  const onChangePage = (index: number) => {
    setCurrentPage(index);

    if (onChangeTab) {
      onChangeTab(index);
    }
  };

  const getNavLinkClassName = (index: number) =>
    `nav-link px-2 py-2 ${currentPage === index ? 'active' : ''}`;

  const tabsContent = () => {
    if (isLoading) return <PageWithTabsLoading />;
    if (isError) return <PageWithTabsError />;

    return tabs[currentPage]?.content;
  };

  return (
    <div className="nk-block pageWithTabs" id={id}>
      <div className="card card-bordered">
        <div className="card-aside-wrap">
          <div className="card-content">
            <ul className="nav nav-tabs nav-tabs-mb-icon nav-tabs-card">
              {tabs.map((tab, index) => (
                <li className="nav-item" key={tab.key}>
                  <p
                    className={getNavLinkClassName(index)}
                    onClick={() => onChangePage(index)}
                  >
                    <em className={`icon ni ${tab.icon}`} />
                    <span>{tab.title}</span>
                  </p>
                </li>
              ))}
            </ul>

            <section className="card-inner">{tabsContent()}</section>
          </div>

          {asideContent || null}
        </div>
      </div>
    </div>
  );
};

export default PageWithTabs;
